/**
 * Get professional display name for a user
 * Returns "Dr. LastName" if available, falls back to full name, then "Doctor"
 */
export function getDisplayName(user) {
  if (!user || !user.name) return "Doctor";
  
  // Check if user object has explicit firstName/lastName fields
  const hasLastName = !!user.lastName && user.lastName.trim().length > 0;
  const hasFirstName = !!user.firstName && user.firstName.trim().length > 0;
  
  if (hasLastName) {
    return `Dr. ${user.lastName}`;
  } else if (hasFirstName) {
    return `Dr. ${user.firstName}`;
  }
  
  // Otherwise, parse the full name field
  let name = user.name.trim();
  
  // Remove "Dr." prefix if present (case-insensitive)
  name = name.replace(/^dr\.\s*/i, '');
  
  // Split name into parts and get last name
  const nameParts = name.split(/\s+/).filter(part => part.length > 0);
  
  if (nameParts.length === 0) {
    return "Doctor";
  } else if (nameParts.length === 1) {
    // Single name - use it
    return `Dr. ${nameParts[0]}`;
  } else {
    // Multiple parts - use last name
    const lastName = nameParts[nameParts.length - 1];
    return `Dr. ${lastName}`;
  }
}

/**
 * Get first name for more casual contexts
 * Falls back to "Doctor" if no name available
 */
export function getFirstName(user) {
  if (!user || !user.name) return "Doctor";
  
  // Check for explicit firstName field
  if (user.firstName && user.firstName.trim().length > 0) {
    return user.firstName;
  }
  
  // Parse from full name
  const name = user.name.trim();
  
  // Remove "Dr." prefix if present
  const cleanName = name.replace(/^dr\.\s*/i, '');
  
  // Get first word as first name
  const nameParts = cleanName.split(/\s+/).filter(part => part.length > 0);
  
  return nameParts.length > 0 ? nameParts[0] : "Doctor";
}
